export const Navigation = (() => {
  const setupNavigation = () => {
    setupClicks()
    addAttributesDesktop()
    setupShortcutLinks()
    setUlHasOpen()
  }

  const toggleAriaHidden = (el: HTMLElement): void => {
    const ariaHidden = el.getAttribute('aria-hidden')
    el.setAttribute('aria-hidden', ariaHidden === 'false' ? 'true' : 'false')
  }

  const toggleAriaExpanded = (el: HTMLElement): void => {
    const ariaExpanded = el.getAttribute('aria-expanded')
    el.setAttribute('aria-expanded', ariaExpanded === 'false' ? 'true' : 'false')
  }

  const toggleExpandText = (el: HTMLElement): void => {
    el.innerHTML = el.innerHTML === 'Minimera' ? 'Expandera' : 'Minimera'
  }

  const setupShortcutLinks = (): void => {
    const contentLink = document.getElementById('maincontent-shortcut') as HTMLAnchorElement | null
    const menuLink = document.getElementById('shortcutmenu') as HTMLElement | null
    const submenuLink = document.getElementById('shortcutsubmenu') as HTMLElement | null
    const mainElement = document.getElementById('main') as HTMLElement | null

    if (!document.getElementById('article') && mainElement && contentLink) {
      mainElement.setAttribute('tabindex', '-1') // Fix för IE
      contentLink.setAttribute('href', '#main')
    }

    if (!document.getElementById('pageMenu') && menuLink) {
      menuLink.style.display = 'none'
    }

    if (!document.getElementById('subMenu') && submenuLink) {
      submenuLink.style.display = 'none'
    }
  }

  const setupClicks = () => {
    const searchToggle = document.querySelector('.searchToggle')
    const menuToggle = document.querySelector('.menuToggle') as HTMLButtonElement
    const pageMenu = document.querySelector('.pageMenu') as HTMLElement
    const searchContainer = document.querySelector('.search > div') as HTMLElement
    const header = document.querySelector('body > header') as HTMLElement
    const shortcutMenu = document.getElementById('shortcutmenu')
    const hasSubnavLinks = document.querySelectorAll('.has-subnav a') as unknown as HTMLAnchorElement[]
    const hasSubnavButtons = document.querySelectorAll('#MainNav .has-subnav button') as NodeListOf<HTMLButtonElement>
    const hasSubnavSpans = document.querySelectorAll('.has-subnav-span') as NodeListOf<HTMLElement>
    const targetLinksToggles = document.querySelectorAll('.anchor-links .toggle') as NodeListOf<HTMLElement>

    if (searchToggle && menuToggle && pageMenu && searchContainer && header) {
      searchToggle.addEventListener('click', (event: Event) => {
        event.preventDefault()

        menuToggle?.classList.remove('selected')

        pageMenu.classList.remove('in')
        pageMenu.classList.add('collapse', 'hide-menu')

        searchToggle.classList.toggle('selected')
        searchContainer.classList.toggle('hide-search')
        header.classList.toggle('search-open')

        return false
      })
    }

    if (menuToggle && searchContainer && searchToggle && header && pageMenu) {
      menuToggle.addEventListener('click', (event: Event) => {
        event.preventDefault()

        const nkpSubMenu = document.querySelector('li.nkpContext')
        if (nkpSubMenu instanceof HTMLElement) {
          nkpSubMenu.classList.add('open')
        }

        searchContainer.classList.add('hide-search')
        searchToggle.classList.remove('selected')
        menuToggle.classList.toggle('selected')
        header.classList.remove('search-open')

        if (pageMenu.offsetParent !== null) {
          pageMenu.classList.add('collapse', 'hide-menu')
        } else {
          pageMenu.classList.remove('collapse', 'hide-menu')
        }
      })
    }

    if (shortcutMenu && pageMenu && menuToggle) {
      shortcutMenu.addEventListener('click', () => {
        if (pageMenu.offsetParent === null) {
          menuToggle.click()
        }
      })
    }

    hasSubnavLinks.forEach((link) => {
      link.addEventListener('click', (evt: MouseEvent) => {
        evt.stopPropagation()
        return true
      })
    })

    hasSubnavButtons.forEach((button) => {
      button.addEventListener('click', (evt: MouseEvent) => {
        evt.stopPropagation()
        toggleMenuClick(button)
        return true
      })
    })

    hasSubnavSpans.forEach((span) => {
      span.addEventListener('click', (evt: MouseEvent) => {
        evt.preventDefault()
        evt.stopPropagation()
        toggleMenuClick(span)
      })
    })

    hasSubnavSpans.forEach((span) => {
      span.addEventListener('keypress', (evt: KeyboardEvent) => {
        if (evt.key === 'Enter') {
          evt.preventDefault()
          toggleMenuClick(span)
          evt.stopPropagation()
        }
      })
    })

    targetLinksToggles?.forEach((toggle) => {
      toggle.addEventListener('click', (evt: MouseEvent) => {
        evt.preventDefault()
        const parent = toggle.parentElement as HTMLElement
        console.log(parent)
        parent.classList.toggle('closed')

        const icon = toggle.querySelector('i')
        if (icon) {
          icon.classList.toggle('fa-plus')
          icon.classList.toggle('fa-minus')
        }
        const span = toggle.querySelector('span')
        if (span) {
          toggleExpandText(span)
        }

        toggleAriaExpanded(toggle)
        const siblingUl = toggle.nextElementSibling as HTMLElement
        if (siblingUl && siblingUl.tagName === 'UL') {
          toggleAriaHidden(siblingUl)
        }

        return false
      })

      const targetLinks = document.querySelectorAll(".anchor-links a[href^='#']") as NodeListOf<HTMLAnchorElement>

      targetLinks.forEach((link) => {
        link.addEventListener('click', (event: MouseEvent) => {
          event.preventDefault()

          const targetSelector = link.getAttribute('href')!
          if (targetSelector.length === 1) {
            return
          }
          const targetNode = document.getElementById(targetSelector.slice(1)) as HTMLElement

          if (targetNode) {
            window.scrollTo({
              top: targetNode.offsetTop,
              behavior: 'smooth',
            })

            window.location.hash = targetSelector

            targetNode.setAttribute('tabindex', '-1')
            targetNode.focus({ preventScroll: true }) //Prevents race condition between scrollTo and focus
          }
        })
      })
    })

    // Show hidden submenus for selected categories
    const selectedCategoryElements = document.querySelectorAll(
      'aside.category-filters ul li.selected ul:first-of-type, aside.category-filters ul li.childSelected ul:first-of-type, aside.category-filters li.childSelected ul.childFacets li.childSelected ul.childFacets',
    ) as NodeListOf<HTMLElement>

    selectedCategoryElements.forEach((element) => (element.style.display = 'block'))

    const categoryFilterHeaders = document.querySelectorAll(
      '.category-filters h3:not(.desktopchoice)',
    ) as NodeListOf<HTMLElement>

    categoryFilterHeaders.forEach((header) => {
      header.addEventListener('click', () => {
        ToggleCategoryFilters()
      })

      header.addEventListener('keypress', (e: KeyboardEvent) => {
        e.preventDefault()
        if (e.key === 'Enter') {
          ToggleCategoryFilters()
        }
      })
    })

    const mobileChoiceButtons = document.querySelectorAll(
      '.category-filters .mobilechoicebtn',
    ) as NodeListOf<HTMLElement>

    mobileChoiceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        ToggleCategoryFiltersSearch()
      })

      button.addEventListener('keypress', (e: KeyboardEvent) => {
        e.preventDefault()
        if (e.key === 'Enter') {
          ToggleCategoryFiltersSearch()
        }
      })
    })
    const ToggleCategoryFiltersSearch = (): void => {
      const filterChoiceContainer = document.querySelector('.category-filters #filterchoicecontainer') as HTMLElement
      const mobileChoiceBtn = document.querySelector('.category-filters .mobilechoicebtn') as HTMLElement
      const iconSpan = document.querySelector('.category-filters .mobilechoicebtn span') as HTMLElement

      if (filterChoiceContainer) {
        filterChoiceContainer.classList.toggle('open')
      }

      if (iconSpan && mobileChoiceBtn) {
        if (!iconSpan.classList.contains('fa-minus')) {
          iconSpan.classList.add('fa-minus')
          mobileChoiceBtn.setAttribute('aria-expanded', 'true')
          let label = mobileChoiceBtn.getAttribute('aria-label') || ''
          label = label + '.'
          mobileChoiceBtn.setAttribute('aria-label', label)
        } else {
          iconSpan.classList.remove('fa-minus')
          mobileChoiceBtn.setAttribute('aria-expanded', 'false')
          let label = mobileChoiceBtn.getAttribute('aria-label') || ''
          label = label.replace('.', '')
          mobileChoiceBtn.setAttribute('aria-label', label)
        }
      }
    }
    const ToggleCategoryFilters = (): void => {
      const filterChoiceContainer = document.querySelector(
        'aside.category-filters #filterchoicecontainer',
      ) as HTMLElement
      const iconSpan = document.querySelector('.category-filters h3 span') as HTMLElement
      const headerElements = document.querySelectorAll('.category-filters h3:not(.desktopchoice)')

      if (filterChoiceContainer) {
        filterChoiceContainer.classList.toggle('open')
      }

      if (iconSpan && headerElements) {
        if (!iconSpan.classList.contains('fa-minus')) {
          iconSpan.classList.add('fa-minus')
          headerElements.forEach((header) => header.setAttribute('aria-expanded', 'true'))
        } else {
          iconSpan.classList.remove('fa-minus')
          headerElements.forEach((header) => header.setAttribute('aria-expanded', 'false'))
        }
      }
    }

    document.querySelectorAll('ul.indexes li a').forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        const parentLi = (event.target as HTMLElement).parentElement
        const siblingLis = parentLi?.parentElement?.children

        if (siblingLis) {
          Array.from(siblingLis).forEach((sibling) => sibling.classList.remove('selected'))
        }

        parentLi?.classList.add('selected')
      })
    })

    const loginUsername = document.querySelector('section#login #UserName') as HTMLElement
    loginUsername?.focus()

    // Cookies bar click event
    const cookieInfo = document.querySelector('div.cookie-info') as HTMLElement
    cookieInfo?.addEventListener('click', () => {
      cookieInfo.style.display = 'none'
    })
  }

  const setUlHasOpen = (): void => {
    const firstUl = document.querySelector('header #pageMenu #MainNav') as HTMLElement | null

    if (!firstUl) return
    const listItems1 = Array.from(firstUl.querySelectorAll('header #pageMenu #MainNav > li'))

    listItems1.forEach((item) => {
      const itemEl = item as HTMLElement
      if (itemEl.classList.contains('open')) {
        firstUl.classList.add('hasopen')
      }

      if (itemEl.classList.contains('has-subnav')) {
        const secondUl = itemEl.querySelector('li .has-subnav > .subnav > ul') as HTMLElement | null
        if (!secondUl) return
        const listItems2 = Array.from(secondUl.querySelectorAll('ul > li'))

        listItems2.forEach((item2) => {
          const item2El = item2 as HTMLElement
          if (item2El.classList.contains('open')) {
            secondUl.classList.add('hasopen')
          }

          if (item2El.classList.contains('has-subnav')) {
            const thirdUl = item2El.querySelector('li .has-subnav > .subnav > ul') as HTMLElement | null
            if (!thirdUl) return

            const listItems3 = Array.from(thirdUl.querySelectorAll('ul > li'))

            for (const item3 of listItems3) {
              const item3El = item3 as HTMLElement
              if (item3El.classList.contains('open')) {
                thirdUl.classList.add('hasopen')
                break
              }
            }
          }
        })
      }
    })
  }

  const toggleMenuClick = (el: HTMLElement): void => {
    const li = el.closest('li') as HTMLElement
    const ul = li.closest('ul') as HTMLElement

    const anyLiOpen = ul.querySelectorAll('li.open:not(.selected)').length

    if (li.classList.contains('open')) {
      li.classList.remove('open')
    } else {
      setTimeout(() => {
        ul.classList.add('hasopen')
        li.classList.add('open')
      }, 200)
    }
    toggleExpandText(el.querySelector('span:not(.expand-border)') as HTMLElement)
    toggleAriaExpanded(el)

    if (anyLiOpen > 0) {
      ul.classList.add('hasopen')
    } else {
      ul.classList.remove('hasopen')
    }
  }

  const addAttributesDesktop = (): void => {
    const mobileSubNavLinks = document.querySelectorAll('.subnav ul a')
    const searchEl = document.querySelector('#PageHead .searchToggle') as HTMLElement

    if (window.innerWidth < 767) {
      mobileSubNavLinks.forEach((link) => (link as HTMLElement).setAttribute('aria-hidden', 'false'))
      searchEl && searchEl.setAttribute('aria-hidden', 'false')
    }
  }

  setupNavigation()
})()
